import React from "react";
import { Colors } from "../../theme/Theme";

/**
 * US6559 Phase 2 — the "Location Managed" value of the Shift Payment field: the location
 * pays the worker directly and RB Pay is not used.
 *
 * Deliberately NEUTRAL, per the client spec: "without a check box and in grey". It is not a
 * warning and not an error — direct payment is a perfectly normal arrangement — so no icon,
 * no amber, no red. The grey lives in the chip (background + border); the label itself is
 * black, because grey-on-grey text was hard to read. Geometry is kept identical to
 * RBPayrollVerifiedBadge so the two chips swap in place without shifting the row.
 */
export const LocationManagedBadge: React.FC<{ style?: React.CSSProperties }> = ({
  style,
}) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#F2F2F2",
      border: `1px solid ${Colors.defaultGrey}`,
      borderRadius: 6,
      padding: "2px 8px",
      lineHeight: 1,
      ...style,
    }}
  >
    <span
      style={{
        color: Colors.black,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      Location Managed
    </span>
  </div>
);
